import { createContext, useContext, type ReactNode } from 'react';
import { useMyWork, type MyWorkCountValue } from './useMyWork';

const MyWorkCountContext = createContext<MyWorkCountValue | null>(null);

/** One shell fetch, shared by the header, the drawer and the page. */
export function MyWorkCountProvider({ children }: { children: ReactNode }) {
  const value = useMyWork(true);
  return <MyWorkCountContext.Provider value={value}>{children}</MyWorkCountContext.Provider>;
}

export function useMyWorkCount(): MyWorkCountValue | null {
  return useContext(MyWorkCountContext);
}

/** Test seam: the page reads this context. Production uses {@link MyWorkCountProvider}. */
export function MyWorkCountTestProvider({
  value,
  children,
}: {
  value: MyWorkCountValue;
  children: ReactNode;
}) {
  return <MyWorkCountContext.Provider value={value}>{children}</MyWorkCountContext.Provider>;
}
